import Store from '../redux/store';
import axios from 'axios';
import {
    Menu, SettingInfo, OrderInfo, Login,
    Order, TurnInfo, CommitDishes, ExtraDishes,
    Condiment, CreateOrder, ServerTest, PrintCartTip, UpdateOrders,
    UpdateExtra, CallService, CheckCart, PrinterTest, Table, CommitDishesResult, UpdateTabStatus, CreateOrderNotCheckTable, HistoryData, GenerateCustomerName, TableStatus, QopCreateOrder, Bulletin, SpecialDishes, Propaganda, Schedule, BusinessMenu, RestaurantInfo, MenuExitInfo, NewBusinessMenu, CourseGroup
} from '../constants/type.constant';
import { WebsocketClient } from '../websocket/module';
import _ from 'lodash';
import moment from 'moment';
import { setLocalDateByDiff } from '../tools/local-moment';

// axios.defaults.timeout = 15000;

export class DefaultRequest {
    /**
     * 测试打印机
     * @param type 设置中的选择的打印机
     * @param theinterface 由设置中的测试时选中的打印机型号,打印机名称,打印机端口拼接成的
     */
    public static async testPrinter(type: string, theinterface: string): Promise<PrinterTest> {
        return await axios.post(`${Store.getState().serverUrl}/api/v1/printer/test/ip`, {
            type,
            theinterface
        });
    }

    /**
     * 测试服务器
     * @param serverUrl 服务器地址
     */
    public static async testServer(): Promise<ServerTest> {
        try {
            return (await axios.get(`${Store.getState().serverUrl}/api/v1/ping`)).data;
        } catch (error) {
            return { ok: -1 };
        }
    }

    /**
     * 测试数据库
     */
    public static async testDatabase(): Promise<void> {
        try {
            return await axios.get(`${Store.getState().serverUrl}/api/v1/kds/test`);
        } catch (error) {
            return;
        }
    }

    /**
     * 登录
     * @param id 账户id
     * @param password  账户密码
     */
    public static async signIn(
        id: number | string,
        password: number | string,
        errorCallBack?: (e: any) => void
    ): Promise<Login> {
        return await axios.post(
            `${Store.getState().serverUrl}/api/v1/kds/employee/login`,
            {
                id,
                password
            }
        );
    }

    /**
     * 获取系统设置
     * @param part 只获取对应的部分设置
     */
    public static async getSettingInfo(part?: number): Promise<Array<SettingInfo>> {
        let newPart: string = '';
        if (part) newPart = `/${part}`;
        return (
            await axios.get(`${Store.getState().serverUrl}/api/v2/settings${newPart}`)
        ).data;
    }

    /**
     * 获取并缓存 所有订单
     * @param extraMenuId 额外费用id
     * @param eatType 就餐方式
     */
    public static async getOrders(
        extraMenuId: number,
        eatType?: string
    ): Promise<Array<Order>> {
        // call api
        return (
            await axios.get(`${Store.getState().serverUrl}/api/v2/orders`, {
                params: {
                    menu_id: extraMenuId,
                    eat_type: eatType
                }
            })
        ).data;
    }

    /**
     * 获取桌台
     * @param section 区域id
     */
    public static async getTables(section?: number): Promise<Array<Table>> {
        return (
            await axios.get(`${Store.getState().serverUrl}/api/v2/tables`, {
                params: {
                    section_id: section,
                    with_order: true
                }
            })
        ).data;
    }
    /**
     * 获取订单详情
     * @param orderId 订单id
     * @param menuId settingInfo菜单id
     */
    public static async getOrderDetail(
        orderId: number,
        menuId: number
    ): Promise<OrderInfo> {
        return (
            await axios.get(`${Store.getState().serverUrl}/api/v2/orders/${orderId}`, {
                params: {
                    menu_id: menuId
                }
            })
        ).data;
    }

    /**
     * 获取菜品
     * @param params.type 菜单类型 0-普通菜单，1-额外费用菜单
     * @param params.print 0:不传或0返回打印相关 1：则不返回
     * @param params.extra 0:不传或0返回额外费用 1：则不返回
     */
    public static async getMenus(params?: {
        type?: number, dish_sort?: string, with_dish?: boolean, print?: 1 | 0,
        extra?: 1 | 0, not_set_caching?: boolean
    }): Promise<Array<Menu>> {
        const MENUS = (
            await axios.get(`${Store.getState().serverUrl}/api/v3/menus`, {
                params: {
                    type: params?.type,
                    with_dish: params?.with_dish ?? true,
                    sort: params?.dish_sort,
                    print: params?.print,
                    extra: params?.extra,
                }
            })
        ).data;
        // if (params?.not_set_caching !== true) {
        //     Store.dispatch({
        //         type: 'SET_CACHING',
        //         path: 'cacheMenus',
        //         value: MENUS
        //     })
        // }
        // WebsocketClient.emit("IS_UPDATE_MENU")
        return MENUS
    }

    /**
     * 旧的
     * 根据一级菜单id获取相应菜品
     */
    public static async old_getMenusItem(id: number, dish_sort?: string): Promise<Array<Menu>> {
        try {
            const data: Menu[] =(
                await axios.get(`${Store.getState().serverUrl}/api/v2/menus/${id}`, {
                    params: {
                        type: 0,
                        with_dish: true,
                        sort: dish_sort
                    }
                })
            ).data;
            return data
        } catch (error) {
           return []
        }
    }

    /**
     * 根据一级菜单id获取相应菜品
     * @param id 一级菜单id
     */
    public static async getMenusItem(id: number, dish_sort?: string): Promise<Array<Menu>> {
        try {
            const data: Menu[] =(
                await axios.get(`${Store.getState().serverUrl}/api/v3/menus2/${id}`, {
                    params: {
                        type: 0,
                        with_dish: true,
                        sort: dish_sort
                    }
                })
            ).data;
            return data
        } catch (error) {
           const res =  await this.old_getMenusItem(id, dish_sort);
           return res;
        }
    }

    /**
     * 查询所有菜单
     */
    public static async getFirstMenuName(): Promise<Array<Menu>> {
        return (
            await axios.get(`${Store.getState().serverUrl}/api/v2/menu_name`)
        ).data;
    }

    /**
     * 获取调味品
     */
    public static async getCondiments(): Promise<Array<Condiment>> {
        // call api
        return (
            await axios.get(`${Store.getState().serverUrl}/api/v2/condiments`, {
                params: {
                    with_group: true
                }
            })
        ).data;
    }

    /**
     * 创建订单
     * @param order 订单信息
     */
    public static async createOrder(order: CreateOrder): Promise<CreateOrder> {
        return (
            await axios.post(`${Store.getState().serverUrl}/api/v2/orders`, {
                ...order
            })
        ).data;
    }

    /**
     * 创建订单 不检查桌台状态
     * @param order 订单信息
     */
    public static async createOrderNotCheckTable(order: QopCreateOrder): Promise<CreateOrderNotCheckTable> {
        return (
            await axios.post(`${Store.getState().serverUrl}/api/v2.5/orders/not-check-table-status`, {
                ...order
            })
        ).data;
    }
    /**
     * 根据一级菜单所关联的数据，产生对应的额外费用
     * @param order 订单信息
     */
    public static async genExtraCostByFirstMenu(extraCost: {
        // 订单id
        id: number,
        // 1级菜单id,数组
        first_menu: Array<number>,
        // 额外费用菜单id
        menu_id: number,
        // 操作人员id
        open_employee_id: number,
        // 操作人员名称
        open_employee_name: number,
        // 当前周几，0-6 0是周日
        week: number
    }): Promise<{}> {
        return (
            await axios.post(`${Store.getState().serverUrl}/api/v2/orders/${extraCost.id}/gen-extra-dish`, {
                ...extraCost
            })
        ).data;
    }


    /**
     * 获取订单当前轮次信息
     * @param orderHeadId 订单号
     * @param menuId 菜单id
     */
    public static async getTurnInfo(
        orderHeadId: number,
        menuId: number
    ): Promise<TurnInfo> {
        return (
            await axios.get(
                `${Store.getState().serverUrl}/api/v2/orders/${orderHeadId}/turn`,
                {
                    params: {
                        menu_id: menuId
                    }
                }
            )
        ).data;
    }

    /**
     * 提交购物车
     * @param orderHeadId 订单号
     * @param postData 提交菜品数据
     * @param vType 接口版本
     */
    public static async commitDishes(orderHeadId: number, postData: CommitDishes, vType = 'v2.5'): Promise<CommitDishesResult> {
        return await axios.post(
            `${Store.getState().serverUrl}/api/${vType}/orders/${orderHeadId}/dishes`,
            postData
        );
    }

    /**
     * 提交购物车前验证
     * @param orderHeadId 订单号
     * @param postData 提交菜品数据
     */
    public static async checkCart(
        orderHeadId: string | number,
        menuId: string | number,
        postData: CommitDishes): Promise<CheckCart> {
        return (await axios.post(`${Store.getState().serverUrl}/api/v2/orders/${orderHeadId}/dishes/check`, {
            id: orderHeadId,
            menu_id: menuId,
            rule: postData.rule,
            dishes: postData.dishes
        })).data;
    }

    /**
     * 提交购物车成功后再调用来打印小票
     * @param postData 提交菜品数据
     * @param retryPrintData 错误时提供的重试打印数据，在打印出错的时候返回
     */
    public static async printCartTip(postData: CommitDishes, retryPrintData?: CommitDishes): Promise<PrintCartTip> {
        return await axios.post(`${Store.getState().serverUrl}/api/v2/printer/sendorder`, {
            ...postData,
            retryPrintData
        }
        );
    }

    /**
     * 修改订单信息
     * @param orders 修改订单的栏位数据
     * customer_num
     * check_name
     * select_menu: string 1,2,3
     */
    public static async updateOrder(
        orders: Array<{
            order_head_id: number;
            [key: string]: any;
        }>
    ): Promise<UpdateOrders> {
        return (
            await axios.patch(`${Store.getState().serverUrl}/api/v2/orders`, { orders })
        ).data;
    }

    /**
     * 修改额外费用
     * @param id 订单号s
     * @param extraDishes 提交额外菜品数据
     * @param openEmployeeId 修改人员id
     * @param openEmployeeName 修改人员名称
     */
    public static async updateExtraDishes(
        orderHeadId: string | number,
        extraDishes: Array<ExtraDishes>,
        openEmployeeId: number,
        openEmployeeName: number
    ): Promise<UpdateExtra> {
        return await axios.post(
            `${Store.getState().serverUrl}/api/v2/orders/extradishes/${orderHeadId}`,
            {
                extraDishes,
                openEmployeeId,
                openEmployeeName
            }
        );
    }

    /**
     * 获取呼叫服务资源
     */
    public static async getCallService(): Promise<CallService> {
        return (await axios.get(`${Store.getState().serverUrl}/api/v2/callservice`, {
            params: {
                id: ''
            }
        })).data;
    }
    /**
     * 获取菜单,普通菜单，特殊菜单
     */
    public static async getCurrentBusinessMenu(): Promise<Array<BusinessMenu>> {
        return (await axios.get(`${Store.getState().serverUrl}/api/v2/menus/getCurrentBusinessMenu`, {
            params: {
                type: 0,
                with_dish: true,
            }
        })).data;
    }
    /**
     * 获取二维码
     */
    public static async getQrcode(host: string, port: number, table_id: number): Promise<string> {
        return (await axios.post(`${Store.getState().serverUrl}/api/v2.5/qrcode`, {
            host,
            port,
            table_id,
        })).data;
    }
    /**
     * 根据桌台id获取当前桌台状态
     */
    public static async getTableSById(table_id: number): Promise<Array<TableStatus>> {
        return (await axios.get(`${Store.getState().serverUrl}/api/v2/tables/${table_id}`)).data;
    }
    /**
     * 根据桌台id修改当前桌台状态
     * @param parm : table_status, cor_status
     */
    public static async updateTableSById(table_id: number, param: { [key: string]: any }): Promise<UpdateTabStatus> {
        return (await axios.patch(`${Store.getState().serverUrl}/api/v2/tables/${table_id}`, {
            ...param
        }));
    }

    /**
     * 根据当前轮次获取历史菜品记录
     * @param orderId 订单id
     * @param menuId 额外费用id
     * @param type 根据传值类型返回相应参数： round,dish,type,rule
     *
     */
    public static async getHistoryDish(orderId: number, menuId: number, type: string): Promise<HistoryData> {
        return (await axios.get(`${Store.getState().serverUrl}/api/v2.5/orders/history-dish/${orderId}`, {
            params: {
                menu_id: menuId,
                type,
            }
        })).data;
    }

    /**
     * 获取自动生成的客户名称
     * @param orderId 订单id
     * @param identifier 设备标识
     */
    public static async getGenerateCustomerName(orderId: number, identifier: string = ''): Promise<GenerateCustomerName> {
        return (await axios.patch(`${Store.getState().serverUrl}/api/v2/orders/${orderId}/gen-customer-name`, {
            identifier,
        })).data
    }

    /**
     * 根据桌台订单的修改桌台状态
     * @param orders customer_num / child_number / other_number / adult_number / select_menu
     */
    public static async updateOrdersStatus(orders: Array<{
        order_head_id: number,
        [key: string]: string | number
    }>): Promise<UpdateTabStatus> {
        return (await axios.patch(`${Store.getState().serverUrl}/api/v2/orders`, {
            orders
        }));
    }
    /**
     * 获取首页公告
     */
    public static async get_bulletin(): Promise<Bulletin> {
        return (await axios.get(`${Store.getState().serverUrl}/api/v2/bulletin/4`));
    }

    /**
     * 获取特色菜
     */
    public static async getSpecialDishes(): Promise<SpecialDishes> {
        try {
            return (await axios.get(`${Store.getState().serverUrl}/api/v2/special_dishes`)).data;
        } catch (error) {
            return false as any;
        }
    }

    /**
     * 查询营业时间
     */
    public static async getSchedule(): Promise<Schedule> {
        try {
            return (await axios.get(`${Store.getState().serverUrl}/api/v2/schedule`)).data;
        } catch (error) {
            return false as any;
        }
    }

    /**
     * 查询平台
     */
    public static async getPropaganda(): Promise<Propaganda> {
        try {
            return (await axios.get(`${Store.getState().serverUrl}/api/v2/propaganda`)).data;
        } catch (error) {
            return false as any;
        }
    }

    /**
     * 营业时间资源
     */
    public static async getBusinessHour(): Promise<BusinessMenu[]> {
        return (await axios.get(`${Store.getState().serverUrl}/api/v2/business-hour`)).data;
    }

    /**
     * 获取餐馆信息
     */
    public static async getRestaurantInfo(): Promise<RestaurantInfo> {
        try {
            return (await axios.get(`${Store.getState().serverUrl}/api/v2/restaurant-info`)).data;
        } catch (error) {
            return false as any;
        }
    }
    /**
     * 查询顶部横幅公告条
     */
    public static async getBannerAnnouncement(): Promise<Propaganda> {
        try {
            return (await axios.get(`${Store.getState().serverUrl}/api/v2/banner-announcement`)).data;
        } catch (error) {
            return false as any;
        }
    }
    /**
     * 查询活动公告
     */
    public static async getActivityBulletin(): Promise<Propaganda | false> {
        try {
            return (await axios.get(`${Store.getState().serverUrl}/api/v2/activity-bulletin/image`)).data;
        } catch (error) {
            return false;
        }
    }

    /**
     * 开台密码验证
     *
     * @param order_head_id 订单id
     * @param order_code 订单临时密码
     */
    public static async getOrderPassword(order_head_id: number, order_code: string): Promise<{ status: number }> {
        try {
            return (
                await axios.post(`${Store.getState().serverUrl}/api/order-password/check`, {
                    order_head_id,
                    order_code
                })
            );
        } catch (error) {
            return { status: _.get(error, 'response.status') || 500 };
        }
    }

    /**
     * 修改订单临时密码
     */
    public static async editOrderPassword(
        employee_id: string,
        password_id: string,
        order_head_id: number,
        new_order_code: string
    ): Promise<{ status: number }> {
        try {
            return (
                await axios.patch(`${Store.getState().serverUrl}/api/order-password/update`, {
                    employee_id,
                    password_id,
                    order_head_id,
                    new_order_code
                })
            );
        } catch (error) {
            return { status: _.get(error, 'response.status') || 500 };
        }
    }

    /**
     * 获取指定菜单额外费用信息
     *
     * @param ids 菜单组string :  ‘20，21，23’
     */
    public static async getMenuExitInfo(ids: string): Promise<Array<MenuExitInfo> | false> {
        try {
            return (
                await axios.get(`${Store.getState().serverUrl}/api/v2/menu_items`, {
                    params: {
                        ids
                    }
                })
            ).data;
        } catch (error) {
            return false;
        }
    }

    /**
     * 新营业时间资源
     */
    public static async getBusinessHour2Project(): Promise<NewBusinessMenu[]> {
        return (await axios.get(`${Store.getState().serverUrl}/api/v3/business_hour2/project`,
            {
                params:
                {
                    project: 'QOP',
                    nowDate: moment(setLocalDateByDiff(Store.getState().diffTimeStamp)).format('YYYY-MM-DD')
                }
            })
        ).data;
    }
    /**
     * 获取套餐区域
     */
    public static async getDishCourse(): Promise<CourseGroup[]> {
        return (await axios.get(`${Store.getState().serverUrl}/api/v3/dish/course`)).data;
    }

    /**
     * 根据菜品id获取菜品沽清详情
     */
     public static async getMenuBargainPriceItem(item_ids: number[]): Promise<any> {
        return (await axios.get(`${Store.getState().serverUrl}/api/v3/bargain_price_item`, {
            params: {
                item_ids: `[${item_ids}]`,
            }
        })).data;
    }

    /**
     * 批量修改数量沽清菜品可选数量
     */
    public static async patchMenuBargainPriceItems(params: Array<{
        bargain_item_id: number;
        bargain_num_cur: number;
    }>): Promise<any> {
        return (await axios.patch(`${Store.getState().serverUrl}/api/v3/bargain_price_item`, params)).data;
    }
}

